export default __webpack_public_path__ + "assets/images/pricing/a52b9eb8034b09b935b6a094c883021a.png";